// extracted by mini-css-extract-plugin
export default {"checkbox":"css-MaQObHdGgD","checkbox_input":"css-bJ8VnW4H9v","checkbox_content":"css-4UcvNFu0Jl","checkbox__cookies":"css-f29i3E7kM9","checkbox__error":"css-WLDtfkGlE8"};